module.exports = __webpack_public_path__ + "img/tree-05-i-trunk.9722f20d.png";